var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (fieldsetCounter, globals, id, validationId) {
      












































pug_mixins["input"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.type) {
attributes.type = 'text'
}
if (!attributes.attributes) {
attributes.attributes = {}
}
if (!attributes.groupAttributes) {
attributes.groupAttributes = {}
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": pug.classes(["form-group",attributes.groupHtmlClass], [false,false])},attributes.groupAttributes]), true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (pug.attr("class", pug.classes(["control-label",attributes.labelHtmlClass], [false,true]), false, true)+pug.attr("for", id, true, true)) + "\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Flabel\u003E";
}
if (attributes.divTitle) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["control-label",attributes.divTitleHtmlClass], [false,true]), false, true)) + "\u003E" + (null == (pug_interp = attributes.divTitle) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cinput" + (pug.attrs(pug.merge([{"class": pug.classes(["form-control",attributes.fieldHtmlClass], [false,true]),"id": pug.escape(id),"type": pug.escape(attributes.type),"placeholder": pug.escape(attributes.placeholder),"ng-model": pug.escape(attributes.key),"ng-disabled": pug.escape(attributes.readonly),"name": pug.escape(id),"value": pug.escape(attributes.value),"required": pug.escape(attributes.required),"ng-pattern": pug.escape(attributes['ng-pattern']),"disabled": pug.escape(attributes.disabled),"data-cy": pug.escape(attributes['data-cy'])},attributes.attributes]), true)) + "\u003E";
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (attributes.validationMessages) {
validationId = '"'+ id +'"'
if (attributes.validationId) {
validationId = attributes.validationId
}
pug_mixins["validationMessages"].call({
attributes: {"key": pug.escape(validationId),"validationMessages": pug.escape(attributes.validationMessages)}
});
}
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};



















































































































pug_mixins["radio"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.title && attributes.name) {
attributes.title = attributes.name
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key + '-' + attributes.index
}
pug_html = pug_html + "\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+pug.attr("id", id, true, true)+" type=\"radio\""+pug.attr("required", attributes.required, true, true)+pug.attr("name", attributes.key, true, true)+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("value", attributes.value, true, true)+pug.attr("ng-value", attributes['ng-value'], true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (" class=\"radio-inline\""+pug.attr("for", attributes.key + '-' + attributes.index, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
};





























































pug_mixins["form"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.name) {
globals.formname = attributes.name
}
pug_html = pug_html + "\u003Cform" + (pug.attrs(pug.merge([{"novalidate": pug.escape(true)},attributes]), true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fform\u003E";
};
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (!fieldsetCounter) {
fieldsetCounter = 0
}





















pug_html = pug_html + "\u003Cdiv class=\"main\" overlay=\"$ctrl.loading.main || $ctrl.loading.data\"\u003E\u003Cdiv class=\"row\" ng-if=\"!basket\"\u003E\u003Cmpp-basket-form-component employee-id=\"$ctrl.employee_id\" on-save=\"$ctrl.boCreatesBasket(savedEvent)\"\u003E\u003C\u002Fmpp-basket-form-component\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"basket\"\u003E\u003Cdiv class=\"columns small-12\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv class=\"vn-table\"\u003E\u003Ctable\u003E\u003Ctbody\u003E\u003Ctr ng-if=\"$ctrl.pc_component\"\u003E\u003Ctd\u003E\u003Cspan\u003EAuftragsstatus NEO\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E{{ $ctrl.pc_component.state.display }}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr ng-if=\"basket.order_process &amp;&amp; $ctrl.MPP_ORDER_STATUSES_BY_ID\"\u003E\u003Ctd\u003E\u003Cspan\u003EAuftragsstatus {{ $ctrl.is_for_bonus_basket ? 'ATRUVIA AG' : 'NEO' }}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E\u003Ca ng-click=\"$ctrl.showStatusLog($event, basket)\"\u003E{{$ctrl.MPP_ORDER_STATUSES_BY_ID[basket.order_process.state_id].display }} - {{ $ctrl.pc_component.state.display }}\u003C\u002Fa\u003E\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr ng-if=\"basket.auftragsnummer || basket.order_id\"\u003E\u003Ctd\u003E\u003Cspan\u003EAuftragsnummer Cyberport\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E{{ basket.auftragsnummer || basket.order_id }}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr ng-if=\"basket.contract_id\"\u003E\u003Ctd\u003E\u003Cspan\u003ELeasingvertrag-Nr.\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E{{ basket.contract_id }}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr ng-if=\"basket.lieferungsnummer\"\u003E\u003Ctd\u003E\u003Cspan\u003ELieferungsnummer\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E{{ basket.lieferungsnummer }}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr ng-if=\"basket.beginDate\"\u003E\u003Ctd\u003E\u003Cspan\u003EBeginn\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E{{ $ctrl.formatDate(basket.beginDate) }}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr ng-if=\"basket.preend_information\"\u003E\u003Ctd\u003E\u003Cspan\u003EVorzeitiges Ende\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E{{$ctrl.formatDate(basket.preend_information.preend_date)}} ({{$ctrl.formatDate(basket.endDate)}})\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr ng-if=\"!basket.preend_information\"\u003E\u003Ctd\u003E\u003Cspan\u003EEnde\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E{{$ctrl.formatDate(basket.endDate)}}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Ctd\u003E\u003Cspan\u003EÜbernahmedatum\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E{{ basket.confirmation.pick_up_date ? $ctrl.formatDate(basket.confirmation.pick_up_date) : '-' }}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Ctd\u003E\u003Cspan\u003EUmwandlungsrate\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E{{ basket.leasing | currency }}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Ctd\u003E\u003Cspan\u003ELeasingrate Netto\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E{{ basket.cart_leasing_month_netto | currency }}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Ctd\u003E\u003Cspan\u003ELeasingrate Brutto\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E{{ basket.cart_leasing_month_brutto | currency }}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Ctd\u003E\u003Cspan\u003EGesamtsumme (Netto)\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E{{ basket.sum | currency }}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Ctd\u003E\u003Cspan\u003EGesamtsumme (Brutto)\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E{{ basket.brutto_base | currency }}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr ng-if=\"!basket.billing_process\"\u003E\u003Ctd\u003E\u003Cspan\u003EAbschlusszahlung (Netto)\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E{{ basket.netto_sum * endprice_percentage | currency }}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr ng-if=\"!basket.billing_process\"\u003E\u003Ctd\u003E\u003Cspan\u003EAbschlusszahlung (Brutto)\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E{{ basket.brutto_sum * endprice_percentage | currency }}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Ctd\u003E\u003Cspan\u003EHandlingsfee Netto\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E{{ basket.configuration.handling_fee | currency }}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr ng-if=\"basket.approval_process\"\u003E\u003Ctd\u003E\u003Cspan\u003EFreigabestatus {{ basket.approval_process.updated_at * 1000 | date }}\u003Ctd\u003E\u003Cspan\u003E{{$ctrl.APPROVAL_PROCESS_STATES_BY_ID[basket.approval_process.state_id]['display']}}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr ng-if=\"$ctrl.is_for_bonus_basket\"\u003E\u003Ctd\u003E\u003Cspan\u003EFreigegebener Leasingumfang\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E{{$ctrl.basket_max_limit}}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr ng-if=\"basket.checkout_config.full_amount \"\u003E\u003Ctd\u003E\u003Cspan\u003EGesamtsumme (Brutto + handling fee)\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E{{ $ctrl.bonus.checkout_config.full_amount | currency }}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr ng-repeat=\"tracking_id_object in basket.trackingIds\"\u003E\u003Ctd\u003E\u003Cspan\u003ESendungsnachverfolgung\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Ca ng-href=\"{{$ctrl.getTrackingURL(tracking_id_object)}}\" target=\"_blank\"\u003E{{tracking_id_object.delivery_service}} - {{ tracking_id_object.tracking_id }}\u003C\u002Fa\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr ng-if=\"basket.otrs\"\u003E\u003Ctd\u003E\u003Cspan\u003EOTRS Ticket\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Ca ng-href=\"{{$ctrl.mppService.getAbsoluteUrl(basket.otrs.ticket_url)}}\" target=\"_blank\"\u003E{{basket.otrs.ticket_number}}\u003C\u002Fa\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr ng-if=\"basket.buying_process_otrs_ticket\"\u003E\u003Ctd\u003E\u003Cspan\u003EAblöseprozess\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Ca ng-href=\"{{basket.buying_process_otrs_ticket.ticket_url}}\" target=\"_blank\"\u003E{{basket.buying_process_otrs_ticket.ticket_number}}\u003C\u002Fa\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr ng-if=\"basket.billing_process\"\u003E\u003Ctd\u003E\u003Cspan\u003EAblöserechnung\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan data-cy=\"vn.administration.pcLeasing.{{basket.employeeId}}-{{basket._id}}.textInvoiceDetails\"\u003E{{basket.billing_process.invoice_id }} - {{ $ctrl.invoice.value_brutto | currency }}  [{{$ctrl.VSP_CONSTANTS.BILLING_STATES_FE_BY_ID[basket.billing_process.state_id].display}}]\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr ng-if=\"basket.preend_information &amp;&amp; basket.preend_information.ticket_number\"\u003E\u003Ctd\u003E\u003Cspan\u003EOTRS Ticket Vorzeitiges Ende\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E{{basket.preend_information.ticket_number}}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Ctd\u003E\u003Cspan\u003EDokumente (Rechnung)\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cdiv ng-if=\"basket.invoices &amp;&amp; basket.invoices.length &gt; 0\" ng-repeat=\"invoice in basket.invoices\"\u003E\u003Ca ng-click=\"$ctrl.openDocument(invoice)\" data-cy=\"vn.administration.pcLeasing.{{basket.employeeId}}-{{basket._id}}.textInvoiceDocuments\"\u003E{{ invoice.filename || 'Dokument' }}\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"basket.invoices.length === 0\"\u003E\u003Cspan\u003E-\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr ng-if=\"basket.documents &amp;&amp; basket.documents.length &gt; 0\"\u003E\u003Ctd\u003EDokumente\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cdiv class=\"hide-overflow\" ng-if=\"basket.documents &amp;&amp; basket.documents.length &gt; 0\" ng-repeat=\"document in basket.documents\"\u003E\u003Ca ng-click=\"$ctrl.openDocument(document)\"\u003E{{document.filename}}\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"basket.documents.length === 0\"\u003E\u003Cspan\u003E-\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr ng-if=\"basket.contact_information\"\u003E\u003Ctd\u003E\u003Cspan\u003Eprivate E-Mail Adresse\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E{{ basket.contact_information.email_address }}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr ng-if=\"basket.contact_information\"\u003E\u003Ctd\u003E\u003Cspan\u003ETelefon\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E{{ basket.contact_information.phone_number }}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Ftbody\u003E\u003C\u002Ftable\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"basket &amp;&amp; !$ctrl.isBasketEditable(basket)\"\u003E\u003Cdiv class=\"columns small-12 side-effect\"\u003E\u003Cdiv class=\"side-scrollable\"\u003E\u003Ctable\u003E\u003Ctr\u003E\u003Cth\u003EPosition\u003C\u002Fth\u003E\u003Cth\u003EArtikelname\u003C\u002Fth\u003E\u003Cth\u003EArtikelnummer\u003C\u002Fth\u003E\u003Cth\u003EEinzel Netto\u003C\u002Fth\u003E\u003Cth\u003EAnzahl\u003C\u002Fth\u003E\u003Cth\u003ESumme Netto\u003C\u002Fth\u003E\u003C\u002Ftr\u003E\u003Ctr ng-repeat=\"article in basket.articles\" ng-class-odd=\"odd\"\u003E\u003Ctd\u003E{{$index + 1}}\u003C\u002Ftd\u003E\u003Ctd\u003E{{article.Artikelname}}\u003C\u002Ftd\u003E\u003Ctd\u003E{{article.Artikelnummer}}\u003C\u002Ftd\u003E\u003Ctd\u003E{{article.netprice | currency}}\u003C\u002Ftd\u003E\u003Ctd\u003E{{article.quantity }}\u003C\u002Ftd\u003E\u003Ctd\u003E{{article.netprice * article.quantity | currency}}\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Ftable\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$ctrl.isBasketEditable(basket)\"\u003E\u003Cdiv class=\"columns medium-4 no-label\"\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.addArticle()\"\u003EArtikel hinzufügen\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"basket &amp;&amp; $ctrl.isBasketEditable(basket)\"\u003E\u003Cdiv class=\"columns small-12 side-effect\"\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_html = pug_html + "\u003Ctable\u003E\u003Ctr\u003E\u003Cth\u003EPosition\u003C\u002Fth\u003E\u003Cth\u003EArtikelname\u003C\u002Fth\u003E\u003Cth\u003EArtikelnummer\u003C\u002Fth\u003E\u003Cth\u003EAnzahl\u003C\u002Fth\u003E\u003Cth\u003ENetto\u003C\u002Fth\u003E\u003C\u002Ftr\u003E\u003Ctr ng-repeat=\"article in basket.articles\" ng-class-odd=\"odd\"\u003E\u003Ctd\u003E{{$index + 1}}\u003C\u002Ftd\u003E\u003Ctd\u003E";
pug_mixins["input"].call({
attributes: {"key": "article.Artikelname","id": "{{basket._id}}-{{$index}}article_name{{ article.Artikelnummer }}","attributes": {"ng-disabled":"!$ctrl.isBasketEditable(basket)"}}
});
pug_html = pug_html + "\u003C\u002Ftd\u003E\u003Ctd\u003E";
pug_mixins["input"].call({
attributes: {"key": "article.Artikelnummer","id": "{{basket._id}}-{{$index}}article_number{{ article.Artikelnummer }}","attributes": {"ng-disabled":"!$ctrl.isBasketEditable(basket)"}}
});
pug_html = pug_html + "\u003C\u002Ftd\u003E\u003Ctd\u003E";
pug_mixins["input"].call({
attributes: {"key": "article.quantity","type": "number","id": "{{basket._id}}-{{$index}}article_quantity{{ article.Artikelnummer }}","attributes": {"ng-disabled":"!$ctrl.isBasketEditable(basket)","ng-change":"$ctrl.compareCartSum()","ng-model-options":"{ updateOn: 'default blur', debounce: { 'default': 500, 'blur': 0 } }"}}
});
pug_html = pug_html + "\u003C\u002Ftd\u003E\u003Ctd\u003E";
pug_mixins["input"].call({
attributes: {"key": "article.netprice","id": "{{basket._id}}-{{$index}}article_netprice{{ article.Artikelnummer }}","attributes": {"ng-if":"$ctrl.isBasketEditable(basket)","ng-change":"$ctrl.compareCartSum()","ng-model-options":"{ updateOn: 'default blur', debounce: { 'default': 500, 'blur': 0 } }","vn-currency":"true"}}
});
pug_html = pug_html + "\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cbutton ng-click=\"$ctrl.removeArticle($index)\"\u003EX\u003C\u002Fbutton\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Ftable\u003E";
},
attributes: {"class": "side-scrollable","name": "$ctrl.forms.edit_basket.basket_form"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$ctrl.isBasketEditable(basket)\"\u003E\u003Cdiv class=\"columns\"\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_mixins["input"].call({
attributes: {"key": "$ctrl.models.edit_basket.edit_basket_comment","title": "Kommentar","id": "edit_basket_comment-{{basket._id}}","required": pug.escape(true),"validationMessages": {"required":"Es wird eine Eingabe benötigt."},"placeholder": "Kommentar\u002F Korrekturhinweis..."}
});
},
attributes: {"name": "$ctrl.forms.edit_basket.comment_form"}
});
pug_html = pug_html + "\u003Cspan class=\"red\" ng-if=\"$ctrl.checkout_check_error\"\u003E{{ $ctrl.checkout_check_error }}\u003C\u002Fspan\u003E\u003Cspan class=\"red\" ng-if=\"$ctrl.over_sum_limit\"\u003EDer Warenkorb darf den Betrag {{ $ctrl.basket_max_limit | currency: 'EUR' }} Brutto nicht überschreiten. Aktuell ist er {{ $ctrl.new_full_amount | currency: 'EUR' }} Brutto.\u003C\u002Fspan\u003E\u003Cspan class=\"red\" ng-if=\"$ctrl.basket_not_linked_to_bonus\"\u003EWarenkorb ist keiner Bonusleistung zugeordnet - vermutlich abgelehnt\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"basket\"\u003E\u003Cdiv class=\"columns small-12\"\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.editBasketGeneralInformation()\"\u003EEditieren\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary right\" ng-click=\"$ctrl.goToNEO(basket.employeeId)\"\u003EZu Neo\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary right\" ng-click=\"$ctrl.goToBonus(basket.employeeId)\"\u003EZu Bonus\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"basket\" ng-hide=\"basket.order_process &amp;&amp; basket.order_process.state_id\"\u003E\u003Cdiv class=\"columns small-12\"\u003E\u003Cbutton class=\"button button-primary right\" ng-click=\"$ctrl.initiateOrderProcess(basket)\"\u003EInitiate Order Process\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"basket.order_process &amp;&amp; $ctrl.MPP_ORDER_STATUSES_BY_NAME &amp;&amp; basket.order_process.state_id === $ctrl.MPP_ORDER_STATUSES_BY_NAME['order_closed']['id']\"\u003E\u003Cdiv class=\"columns small-12\"\u003E\u003Cbutton class=\"button button-primary right\" ng-click=\"$ctrl.transferBasketToMySQL(basket._id)\"\u003EExport MySQL\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary right\" ng-if=\"!$ctrl.hideSendOrderEmailToLeasingCompanyButton\" ng-click=\"$ctrl.sendOrderEmailToLeasingCompany(basket)\"\u003EEmail an Leasing\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C!-- baskets without type are baskets which have not been created manually--\u003E\u003Cdiv class=\"row\" ng-if=\"basket\"\u003E\u003Cdiv class=\"columns small-12\"\u003E\u003Ca class=\"right button button-default\" href=\"\u002Fberater?employeeId={{basket.employeeId}}\"\u003ERechner\u003C\u002Fa\u003E\u003Ca class=\"right button button-default\" href=\"\u002Fmpp?employeeId={{basket.employeeId}}\" ng-if=\"basket.state == 'checkout' || basket.state == 'created' || basket.state == 'saved'|| basket.state == 'attention'\"\u003EAnpassen\u003C\u002Fa\u003E\u003Cbutton class=\"right button button-default\" ng-click=\"$ctrl.updateBasket()\" overlay=\"$ctrl.loading.update_basket\" ng-if=\"$ctrl.isBasketEditable(basket)\" ng-disabled=\"!$ctrl.canUpdateBasket()\"\u003ESpeichern\u003C\u002Fbutton\u003E\u003C!-- storno with order process--\u003E\u003Cbutton class=\"left button button-default alert\" ng-if=\"$ctrl.canOpenCancelOrderDialog(basket)\" ng-click=\"$ctrl.openCancelOrderDialog($event, basket)\"\u003EStornieren\u003C\u002Fbutton\u003E\u003Cbutton class=\"left button button-default alert\" ng-if=\"$ctrl.allowToResetOrder(basket.id)\" ng-click=\"$ctrl.openResetOrderDialog(basket)\"\u003EEntscheidung zurücksetzen\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary\" ng-if=\"$ctrl.canUpload(basket)\" ng-click=\"$ctrl.openOrderProcessDocumentUploadDialog(basket, $event)\"\u003EDokument hochladen\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary\" ng-if=\"basket.order_process\" ng-click=\"$ctrl.generateContract(basket)\"\u003ENutzungsüberlassung\u003C\u002Fbutton\u003E\u003Cbutton class=\"right button button-default\" ng-if=\"$ctrl.isOrderProcessNeedsChanges()\" overlay=\"$ctrl.loading.order_process.confirm_changes\" ng-click=\"$ctrl.confirmBasketChanges()\" ng-disabled=\"!$ctrl.isOrderProcessNeedsChanges()\"\u003EFreigabe anstoßen\u003C\u002Fbutton\u003E\u003Cbutton class=\"right button button-default\" ng-if=\"$ctrl.isOrderClosed() &amp;&amp; !$ctrl.isBasketCancelled() &amp;&amp; !$ctrl.isBasketPreended()\" ng-click=\"$ctrl.openCancelPCDialog(basket)\" data-cy=\"vn.administration.pcLeasing.{{basket.employeeId}}-{{basket._id}}.buttonPreendBasket\"\u003EVorzeitiges Ende\u003C\u002Fbutton\u003E\u003Cbutton class=\"right button button-default\" ng-if=\"$ctrl.isOrderClosed() &amp;&amp; $ctrl.isBasketPreended()\" ng-click=\"$ctrl.openRemovePreendDialog()\" data-cy=\"vn.administration.pcLeasing.{{basket.employeeId}}-{{basket._id}}.buttonRemovePreendBasket\"\u003EVorzeitiges Ende zurücknehmen\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C!-- always available functionality--\u003E\u003Cdiv class=\"row\" ng-if=\"basket\"\u003E\u003Cdiv class=\"columns\"\u003E\u003C!-- storno without order process--\u003E\u003Cbutton class=\"button button-secondary alert\" ng-click=\"$ctrl.delete(basket)\" ng-if=\"$ctrl.canDeleteBasket(basket)\"\u003ELöschen\u003C\u002Fbutton\u003E\u003C!--button.right.button.button-default(ng-if=\"$ctrl.canOpenContractDialog(basket)\" ng-click=\"$ctrl.openContractDialog($event, basket)\") Leasingvertragsnummer--\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "fieldsetCounter" in locals_for_with ?
        locals_for_with.fieldsetCounter :
        typeof fieldsetCounter !== 'undefined' ? fieldsetCounter : undefined, "globals" in locals_for_with ?
        locals_for_with.globals :
        typeof globals !== 'undefined' ? globals : undefined, "id" in locals_for_with ?
        locals_for_with.id :
        typeof id !== 'undefined' ? id : undefined, "validationId" in locals_for_with ?
        locals_for_with.validationId :
        typeof validationId !== 'undefined' ? validationId : undefined));
    ;;return pug_html;};
module.exports = template;